/**
 * Single place: axios base URL for backend routes that live under /api/*.
 *
 * Set REACT_APP_API_URL to the **API origin** only, without a trailing slash, e.g.:
 *   http://localhost:3000
 *   https://api.yourdomain.com
 *
 * This helper ensures the base always ends with `/api`, so request paths should be
 * **suffix only**: `/media`, `/auth/login` → never `/api/media` on top of a base that
 * already includes `/api` (that would produce /api/api/...).
 *
 * If you already include `/api` in the env (e.g. https://x.com/api), it is kept as-is.
 */
export function getApiBaseUrl() {
  const raw = (process.env.REACT_APP_API_URL || '/api').trim()
  if (!raw) return '/api'

  const noTrailing = raw.replace(/\/+$/, '')
  if (noTrailing.toLowerCase().endsWith('/api')) {
    return noTrailing
  }

  if (/^https?:\/\//i.test(noTrailing)) {
    try {
      const u = new URL(noTrailing)
      const path = u.pathname.replace(/\/$/, '') || ''
      if (path === '' || path === '/') {
        return `${u.origin}/api`
      }
      // Non-root URL (custom gateway path): use env as the full API base as-is
      return noTrailing
    } catch {
      return `${noTrailing}/api`
    }
  }

  if (noTrailing === '/api') return '/api'
  return `${noTrailing}/api`
}
